export default __webpack_public_path__ + "static/media/bars.1edf6499.svg";